import styled from 'styled-components';

export const $NoteContainer = styled.div`
  font-size: ${({ theme }) => theme.fonts.size.small};
  line-height: 1rem;
`;
